import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import SecureLS from 'secure-ls'
import { setAuthorizationHeader } from 'src/api/userAPI'
import { clearTicketListState } from 'src/views/pages/ticket/utils/ticketListState'
import {
  loginHandler,
  logoutSuccess,
  updatePlanSuccess,
  updateShowSideBar,
  updateSuccess,
  updateCompanySuccess,
  updateProfilePicture,
} from './authSlice'

const secureLs = new SecureLS()

const updateStateInStorage = (newState) => {
  secureLs.set('appc-auth-mkplace', newState)
}

const listenerMiddleware = createListenerMiddleware()

const effect = (action, listenerApi) => {
  if (logoutSuccess.pending.match(action) || loginHandler.fulfilled.match(action)) {
    clearTicketListState()
  }

  const userState = listenerApi.getState().authReducer.user
  updateStateInStorage(userState)

  if (action?.meta?.requestStatus === 'fulfilled' || action?.type === updateCompanySuccess.type) {
    setAuthorizationHeader(userState)
  }
}

listenerMiddleware.startListening({
  matcher: isAnyOf(
    loginHandler,
    logoutSuccess,
    updateSuccess,
    updatePlanSuccess,
    updateShowSideBar,
    updateCompanySuccess,
    updateProfilePicture,
  ),
  effect,
})

export default listenerMiddleware.middleware
